import { TimeUnit } from '../hooks/useLicenseStats';

// Escape hatch to stop UI locking up if there are too many points
const MAX_POINTS = 10000;

const increment = (date: Date, granularity: TimeUnit): Date => {
  switch (granularity) {
    case 'second':
      return new Date(date.getTime() + 1000);
    case 'minute':
      return new Date(date.getTime() + 60000);
    case 'hour':
      return new Date(date.getTime() + 3600000);
    case 'day':
      return new Date(date.getTime() + 86400000);
    case 'month':
      return new Date(date.getTime() + 2592000000);
    default:
      return new Date(date.getTime() + 31536000000);
  }
};

const roundDown = (date: Date, granularity: TimeUnit): Date => {
  switch (granularity) {
    case 'second':
      return new Date(date.setMilliseconds(0));
    case 'minute':
      return new Date(date.setSeconds(0, 0));
    case 'hour':
      return new Date(date.setMinutes(0, 0));
    default:
      return new Date(date.setHours(0, 0, 0, 0));
  }
};

/**
 * @todo infill
 */
export const fillTimeSeries = (
  data: { x: string; y: number }[],
  granularity: TimeUnit
): { x: string; y: number }[] => {
  if (data.length < 2) {
    return data;
  }

  const series = [data[0]];
  let current = roundDown(new Date(data[0].x), granularity);
  let i = 1;

  while (i < data.length && series.length < MAX_POINTS) {
    const nextDatePoint = roundDown(
      increment(current, granularity),
      granularity
    );

    const nextItemDate = roundDown(new Date(data[i].x), granularity);

    if (nextDatePoint < nextItemDate) {
      series.push({ x: nextDatePoint.toISOString(), y: 0 });
      current = nextDatePoint;
    } else {
      series.push(data[i]);
      current = nextItemDate;
      i++;
    }
  }

  return series;
};
